
const digest = '1f48c056c1f2e999b4335145d65cefa93af8054ddfc95d448e6554072b32410d';
const classes = {"wrapper":"_wrapper_1hzsv_1","input":"_input_1hzsv_5","errorMessage":"_errorMessage_1hzsv_28","invalid":"_invalid_1hzsv_34","disabled":"_disabled_1hzsv_38"};
const css = `._wrapper_1hzsv_1 {
  margin-bottom: 10px;
}

._input_1hzsv_5 {
  height: auto;
  border: 1px solid #e2e5ed !important;
  min-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px;
  color: #000;
  background-color: #fff;
  line-height: 20px;
  width: 100%;
  display: block;
}
._input_1hzsv_5:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}

._errorMessage_1hzsv_28 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: red;
}

._invalid_1hzsv_34 {
  border-color: red !important;
}

._disabled_1hzsv_38 {
  background-color: #f3f3f3;
  opacity: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  